import React, { useEffect, useState } from 'react'
import { toAbsoluteUrl, KTSVG } from '../../../helpers'
import { IProfileDetails, profileDetailsInitValues as initialValues } from '../../../../app/modules/accounts/components/settings/SettingsModel'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { LanguageHelp, getConfig } from '../../../../_metronic/helpers/LanguageHelper'
import { updateCompany } from '../../../../app/modules/auth/core/_requests'
import { useAuth } from '../../../../app/modules/auth'
import * as authHelper from '../../../../app/modules/auth/core/AuthHelpers'
import { toast } from 'react-toastify';
import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'

const lang = getConfig()

const plans = [
  {
    value: 1,
    title: LanguageHelp('Starter'),
    subTitle: LanguageHelp('5,000 texts per month.'),
    subTitle2: LanguageHelp('After each 1000 texts {price}. (Optional)').replace("{price}", '1,5$'),
    description: LanguageHelp('Best for startups'),
    priceMonth: '49',
    priceAnnual: '499',
    default: true,
    custom: false,
    features: [
      {
        title: LanguageHelp('1 User'),
        supported: true,
      },
      {
        title: LanguageHelp('7/24 Access'),
        supported: true,
      },
      {
        title: LanguageHelp('Email Integration'),
        supported: true,
      },
      {
        title: LanguageHelp('Mobile Application'),
        supported: true,
      },
      {
        title: LanguageHelp('Proactive Notifications'),
        supported: true,
      },
      {
        title: LanguageHelp('Facebook'),
        supported: false,
      },
      {
        title: LanguageHelp('Instagram'),
        supported: true,
      },
      {
        title: LanguageHelp('Twitter'),
        supported: true,
      },
      {
        title: LanguageHelp('TikTok'),
        supported: true,
      },
      {
        title: LanguageHelp('Youtube'),
        supported: true,
      },
      {
        title: LanguageHelp('Linkedin'),
        supported: false,
      },
      {
        title: LanguageHelp('Reddit'),
        supported: false,
      },
      {
        title: LanguageHelp('Google Places'),
        supported: false,
      },
      {
        title: LanguageHelp('News'),
        supported: false,
      },
      {
        title: LanguageHelp('Api'),
        supported: false,
      },
    ],
  },

  {
    value: 2,
    title: LanguageHelp('Team'),
    subTitle: LanguageHelp('12,000 texts per month.'),
    subTitle2: LanguageHelp('After each 1000 texts {price}. (Optional)').replace("{price}", '1,3$'),
    description: LanguageHelp('Optimal for normal usage and midsize company'),
    priceMonth: '129',
    priceAnnual: '1299',
    default: false,
    custom: false,
    features: [
      {
        title: LanguageHelp('5 Users'),
        supported: true,
      },
      {
        title: LanguageHelp('7/24 Access'),
        supported: true,
      },
      {
        title: LanguageHelp('Email Integration'),
        supported: true,
      },
      {
        title: LanguageHelp('Mobile Application'),
        supported: true,
      },
      {
        title: LanguageHelp('Proactive Notifications'),
        supported: true,
      },
      {
        title: LanguageHelp('Facebook'),
        supported: false,
      },
      {
        title: LanguageHelp('Instagram'),
        supported: true,
      },
      {
        title: LanguageHelp('Twitter'),
        supported: true,
      },
      {
        title: LanguageHelp('TikTok'),
        supported: true,
      },
      {
        title: LanguageHelp('Youtube'),
        supported: true,
      },
      {
        title: LanguageHelp('Linkedin'),
        supported: true,
      },
      {
        title: LanguageHelp('Reddit'),
        supported: true,
      },
      {
        title: LanguageHelp('Google Places'),
        supported: false,
      },
      {
        title: LanguageHelp('News'),
        supported: false,
      },
      {
        title: LanguageHelp('Api'),
        supported: false,
      },
    ],
  },

  {
    value: 3,
    title: LanguageHelp('Professional'),
    subTitle: LanguageHelp('15,000 texts per month.'),
    subTitle2: LanguageHelp('After each 1000 texts {price}. (Optional)').replace("{price}", '1,1$'),
    description: LanguageHelp('Optimal for best usage and largesize company'),
    priceMonth: '299',
    priceAnnual: '2999',
    label: LanguageHelp('Most popular'),
    default: false,
    custom: false,
    features: [
      {
        title: LanguageHelp('10 Users'),
        supported: true,
      },
      {
        title: LanguageHelp('7/24 Access'),
        supported: true,
      },
      {
        title: LanguageHelp('Email Integration'),
        supported: true,
      },
      {
        title: LanguageHelp('Mobile Application'),
        supported: true,
      },
      {
        title: LanguageHelp('Proactive Notifications'),
        supported: true,
      },
      {
        title: LanguageHelp('Facebook'),
        supported: true,
      },
      {
        title: LanguageHelp('Instagram'),
        supported: true,
      },
      {
        title: LanguageHelp('Twitter'),
        supported: true,
      },
      {
        title: LanguageHelp('TikTok'),
        supported: true,
      },
      {
        title: LanguageHelp('Youtube'),
        supported: true,
      },
      {
        title: LanguageHelp('Linkedin'),
        supported: true,
      },
      {
        title: LanguageHelp('Reddit'),
        supported: true,
      },
      {
        title: LanguageHelp('Google Places'),
        supported: true,
      },
      {
        title: LanguageHelp('News'),
        supported: true,
      },
      {
        title: LanguageHelp('Api') + '(+ 49 $)',
        supported: true,
      },
    ],
  },

  {
    value: 4,
    title: LanguageHelp('Enterprise'),
    subTitle: LanguageHelp('25,000 texts per month.'),
    subTitle2: LanguageHelp('After each 1000 texts {price}. (Optional)').replace("{price}", '0,8$'),
    description: LanguageHelp('Optimal for best usage and software developers'),
    priceMonth: '499',
    priceAnnual: '4999',
    default: false,
    custom: false,
    features: [
      {
        title: LanguageHelp('25 Users'),
        supported: true,
      },
      {
        title: LanguageHelp('7/24 Access'),
        supported: true,
      },
      {
        title: LanguageHelp('Email Integration'),
        supported: true,
      },
      {
        title: LanguageHelp('Mobile Application'),
        supported: true,
      },
      {
        title: LanguageHelp('Proactive Notifications'),
        supported: true,
      },
      {
        title: LanguageHelp('Facebook'),
        supported: true,
      },
      {
        title: LanguageHelp('Instagram'),
        supported: true,
      },
      {
        title: LanguageHelp('Twitter'),
        supported: true,
      },
      {
        title: LanguageHelp('TikTok'),
        supported: true,
      },
      {
        title: LanguageHelp('Youtube'),
        supported: true,
      },
      {
        title: LanguageHelp('Linkedin'),
        supported: true,
      },
      {
        title: LanguageHelp('Reddit'),
        supported: true,
      },
      {
        title: LanguageHelp('Google Places'),
        supported: true,
      },
      {
        title: LanguageHelp('News'),
        supported: true,
      },
      {
        title: LanguageHelp('Api'),
        supported: true,
      },
    ],
  },

  // {
  //   title: LanguageHelp('Custom'),
  //   subTitle: LanguageHelp('Request a custom license'),
  //   default: false,
  //   custom: true,
  // },
]

const profileDetailsSchema = Yup.object().shape({
})

const UpgradePlan: React.FC = () => {
  const [currentState, setCurrentState] = useState<'month' | 'annual'>('month')
  const { auth, saveAuth } = useAuth()
  const [selected, setSelected] = useState(auth?.result.membershipType)
  const [loading, setLoading] = useState(false)
  const { mode } = useThemeMode()

  useEffect(() => {
    if (auth === undefined) {
      saveAuth(authHelper.getAuth())
    }
    setSelected(auth?.result.membershipType)
  }, [])

  const formik = useFormik<IProfileDetails>({
    initialValues,
    validationSchema: profileDetailsSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setLoading(true)
      try {
        if (auth === undefined) {
          auth = authHelper.getAuth()
        }
        const { data: authNew } = await updateCompany(
          auth?.result.companyName as string,
          auth?.result.companyLanguage as string,
          auth?.result.companyTimeZone as string,
          auth?.result.companyTimeZone as string,
          auth?.result.companyCountry as string,
          auth?.result.companyWebsite as string,
          auth?.result.companyPhone as string,
          selected as number,
          '',
        )
        setLoading(false)

        if (authNew.httpStatusCode === 400) {
          toast.error(LanguageHelp(authNew.message))
        }
        else {
          var auth = authHelper.getAuth()
          auth!.result.companyName = authNew.result.companyName;
          auth!.result.companyTimeZone = authNew.result.companyTimeZone;
          auth!.result.companyPhone = authNew.result.companyPhone;
          auth!.result.companyLanguage = authNew.result.companyLanguage;
          auth!.result.companyWebsite = authNew.result.companyWebsite;
          auth!.result.companyCountry = authNew.result.companyCountry;
          auth!.result.membershipType = authNew.result.membershipType;
          saveAuth(auth)

          if (authNew.message != null && authNew.message !== "") {
            toast.warning(LanguageHelp(authNew.message), { autoClose: 5000 })
          } else {
            toast.success(LanguageHelp('Membership type updated successfully!'))
          }
        }

      } catch (ex) {
        if (ex instanceof Error) {
          toast.error(LanguageHelp(ex.message));
        } else {
          toast.error(LanguageHelp('An unexpected error has occurred'));
          console.log('Unexpected error', ex);
        }
        setLoading(false)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <div className='modal fade' id='kt_modal_upgrade_plan' aria-hidden='true'>
      <div className='modal-dialog modal-xl'>
        <div className='modal-content rounded'>
          <div className='modal-header justify-content-end border-0 pb-0'>
            <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal'>
              <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
            </div>
          </div>

          <div className='modal-body pt-0 pb-15 px-5 px-xl-20'>
            <div className='mb-13 text-center'>
              <h1 className='mb-3'>{LanguageHelp('Upgrade Plan')}</h1>

              <div className='text-muted fw-bold fs-5'>
                {LanguageHelp('If you need more info, please write to us:')} {' '}
                <a href='mailto:info@aisenseus.net' className='link-primary fw-bolder'>
                  {LanguageHelp('Send Email')}
                </a>
                .
              </div>
            </div>

            <form onSubmit={formik.handleSubmit} noValidate className='form'>
              <div className='d-flex flex-column'>
                <div className='nav-group nav-group-outline mx-auto' data-kt-buttons='true'>
                  <a
                    href='#'
                    className={
                      'btn btn-color-gray-600 btn-active btn-active-secondary px-6 py-3 me-2 ' +
                      (currentState === 'month' && 'active')
                    }
                    onClick={() => {
                      setCurrentState('month')
                    }}
                    data-kt-plan='month'
                  >
                    {LanguageHelp('Monthly')}
                  </a>
                  <a
                    href='#'
                    className={
                      'btn btn-color-gray-600 btn-active btn-active-secondary px-6 py-3 me-2 ' +
                      (currentState === 'annual' && 'active')
                    }
                    onClick={() => {
                      setCurrentState('annual')
                    }}
                    data-kt-plan='annual'
                  >
                    {LanguageHelp('Annual')}
                  </a>
                </div>
                <div className='mt-5 mb-5 text-center'>
                  <div className='w-bold fs-5'>
                    {LanguageHelp('Up to ')}
                    <span className='link-primary fw-bolder'>
                      {LanguageHelp('17% discount')}
                    </span>
                    {LanguageHelp(' is applied to the annual selection.')}
                  </div>
                </div>

                <div className='row'>
                  {plans.map((plan, index) => {
                    return (
                      <div className='col-xl-3'
                        key={index}
                      >
                        <div className="d-flex h-100 align-items-center"
                          onClick={() => {
                            setSelected(plan.value)
                          }}
                          data-bs-target={`#kt_upgrade_plan_${index}`}
                          style={{ cursor: 'pointer' }}>
                          <div className="w-100 d-flex flex-column flex-center rounded-3 bg-light bg-opacity-75 py-10 px-10"
                            style={{
                              WebkitBoxShadow: `${selected === plan.value ? 'inset 0px 0px 0px 4px #009ef7' : ''}`,
                              MozBoxShadow: `${selected === plan.value ? 'inset 0px 0px 0px 4px #009ef7' : ''}`,
                              boxShadow: `${selected === plan.value ? 'inset 0px 0px 0px 4px #009ef7' : ''}`
                            }}
                          >
                            <div className="mb-7 text-center">
                              <h1 className="text-dark mb-5 fw-bolder">{plan.title}</h1>
                              {/* <div style={{ height: '55px', display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                                <div className="fw-semibold text-gray-800 fs-6">{plan.description}</div>
                              </div> */}
                              <div style={{ height: '55px', display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                                <div className='fw-semibold text-gray-800'>{plan.subTitle}</div>
                              </div>
                              <div style={{ height: '40px', display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                                <div className='fw-semibold text-gray-800'>{plan.subTitle2}</div>
                              </div>
                              <div className="text-center">
                                <span className="mb-2 text-primary">$</span>
                                <span className="fs-3x fw-bold text-primary">{currentState === 'month' ? plan.priceMonth : plan.priceAnnual}</span>
                                <span className="fs-7 fw-semibold opacity-50">/
                                  <span data-kt-element="period">{!plan.custom && currentState === "annual" ? LanguageHelp('Year') : LanguageHelp('Month')}</span>
                                </span>
                              </div>
                            </div>

                            <div className="w-100 mb-10">

                              {plan.features!.map((feature, i) => {
                                return (
                                  <div
                                    className={
                                      `d-flex align-items-center` +
                                      (i !== plan.features!.length - 1 && ' mb-5')
                                    }
                                    key={`${i}-${feature.title}`}
                                  >
                                    {feature.supported && (
                                      <>
                                        <span className='fw-semibold fs-6 text-gray-800 flex-grow-1'>
                                          {feature.title}
                                        </span>

                                        <KTSVG
                                          path='/media/icons/duotune/general/gen043.svg'
                                          className='svg-icon-1 svg-icon-success'
                                        />
                                      </>
                                    )}
                                    {!feature.supported && (
                                      <>
                                        <span className='fw-semibold fs-6 text-gray-600 flex-grow-1'>
                                          {feature.title}
                                        </span>
                                        <KTSVG
                                          path='/media/icons/duotune/general/gen040.svg'
                                          className='svg-icon-1'
                                        />
                                      </>
                                    )}
                                  </div>
                                )
                              })}
                            </div>
                            <div className='form-check form-check-custom form-check-solid form-check-success'>
                              <input
                                className='form-check-input'
                                style={{ cursor: 'pointer', backgroundColor: `${selected !== plan.value ? (mode === 'light' ? '#dee0e7' : '#515168') : ''}` }}
                                type='radio'
                                name='plan'
                                value={plan.value}
                                checked={selected === plan.value}
                                onChange={(e) => setSelected(Number(e.target.value))}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>

              <div className='d-flex flex-center flex-row-fluid pt-12'>
                <button type='reset' className='btn btn-light me-3' data-bs-dismiss='modal'>
                  {LanguageHelp('Cancel')}
                </button>

                <button type='submit' className='btn btn-primary' disabled={loading} data-bs-dismiss='modal'>
                  {!loading && LanguageHelp('Save')}
                  {loading && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      {LanguageHelp('Please Wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export { UpgradePlan }
